import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Navbar, Footer } from "../components/SiteChrome";

const BookingCancelled = () => (
  <div>
    <Navbar />
    <section className="max-w-3xl mx-auto px-6 py-24 md:py-32 text-center">
      <XCircle className="w-10 h-10 text-[#5c5a56] mx-auto mb-6" />
      <h1 className="font-display text-3xl md:text-5xl font-semibold tracking-tight">
        Payment was cancelled.
      </h1>
      <p className="text-[#5c5a56] mt-4 max-w-md mx-auto">
        No charge was made. Your time slot wasn&rsquo;t reserved. Want to try again?
      </p>
      <Link to="/#services" data-testid="cancelled-cta" className="btn-primary mt-8 inline-flex">
        Back to services
      </Link>
    </section>
    <Footer />
  </div>
);

export default BookingCancelled;
